export const pages = [
    {
        id: 1,
        label: 'Home',
        route: '/',
        mobile: false
    },
    {
        id: 2,
        label: 'Jackpots',
        route:'#',
        dropDown: [
            {
                id:1,
                label: "Sportpesa",
                route: '/Sportpesa'
            },
            {
                id:2,
                label: "Betika",
                route: "/Betika",
            },
            {
                id:3,
                label: "BetPawa",
                route: "/BetPawa"
            },
            {
                id:4,
                label: "SportyBet",
                route: "/SportyBet"
            },
            {
                id:5,
                label: "Mozzart",
                route: "/Mozzart"
            },
            {
                id:6,
                label: "BongoBongo",
                route: "/BongoBongo"
            },
        ],
        mobile: false
    },
    {
        id: 3,
        label: 'Predictions',
        route:'#',
        dropDown: [
            {
                id:1,
                label: "Fixed Matches",
                route: '/Fixed-Matches'
            },
            {
                id:2,
                label: "VIP Tips",
                route: "/VIP",
            },
            {
                id:3,
                label: "Premium",
                route: "/Premium"
            },

        ],
        mobile: false

    },
    {
        id: 4,
        label: "Multi Bets",
        route: '/Multibets',
        mobile: false
    },
    {
        id: 5,
        label: "Pricing",
        route: "/Pricing",
        mobile: true
    },
    {
        id: 6,
        label: "Blog",
        route: "/Blog",
        mobile: true
    }];
